import PropTypes from 'prop-types'

const ButtonTrigger = ({ trigger, active }) => (
  <button
    aria-label="Compartilhar"
    className={`glyph glyph-share icon-share-trigger ${active ? 'active' : ''}`}
    onClick={trigger}
  />
)

ButtonTrigger.propTypes = {
  trigger: PropTypes.func.isRequired
}

export default ButtonTrigger
